
export default {
  element: 'fieldset',
  mutate: function mutate(element) {
    element.innerHTML = '<legend>legend</legend><p>content</p>';
  }
};
//# sourceMappingURL=focus-fieldset.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/focus-fieldset.js
// module id = 181
// module chunks = 0 1